import React from 'react';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';

//Helper
import { withQuery } from '../../../hoc/withGraphql';
import AIFeatureManagement from '../../../components/siteadmin/AIFeatures/AIFeatureManagement';
import Loader from '../../../components/Loader/Loader';

const AdminAIFeatures = (props) => {
    const { data: { loading, siteSettings }, title } = props;

    if (loading) {
        return <Loader type="text" />;
    }
    const settingsCollection = {};
    siteSettings?.forEach(item => {
        settingsCollection[item?.name] = item?.value;
    });

    return <AIFeatureManagement initialValues={settingsCollection} title={title} />;

};


export default compose(
    withQuery(gql`
        {
          siteSettings {
            name
            value
          }
        }
      `, {
        options: (props) => ({
            variables: {
                type: 'ai_features',
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }
    ),
)(AdminAIFeatures);

